import React, { useState } from "react";

import Navbar from '../Navbars/Navbar'
import { NavLink } from "react-router-dom";
// @ts-ignore
import Carousel from 'react-grid-carousel'

import Footer from '../Footer';
import Testimonials from './Testimonials';
import OurClient from './OurClient';
import { useNavigate } from "react-router-dom";

function Home() {

  const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputValue.trim()) {
      navigate("/tracking-page", { state: { value: inputValue } }); // Pass data via state
    }
  };

  return (
    <>
      <Navbar />
      {/* Start Section autoplay={3000} */}
      <div className='' style={{ paddingRight: '1px !important' }}>
        <Carousel cols={1} rows={1} gap={0} mobileBreakpoint={20} loop className="carousel-wrapper">
          <Carousel.Item className="carousel-slide">
            <div className="relative" >
              <img src="/images/banner1.png" alt="hero" className='w-full' />
              <div className="absolute top-1 md:top-28 lg:top-48 left-10">
                <img src="/images/mostTrusted.png" alt="hero" className='md:w-[500px] w-[200px]' />
                <div className='md:pl-7 pl-0'>
                  <h1 className="text-white text-[20px] md:text-[70px] font-black md:leading-[70px] leading-[20px] ">The Fastest Way to<br /> Send What Matters </h1>
                  <div className='md:w-[470px] w-[270px] h-[4px] bg-[#fff] md:mt-6 mt-2'></div>
                  <div className='md:pt-6 pt-2'>
                    <h3 className="text-white md:text-[30px] text-[12px] uppercase font-bold md:leading-[35px]">  Ship Now with Confidence <br />and Peace of Mind!</h3>
                  </div>

                  <div className="flex flex-wrap gap-2 md:gap-4 md:mt-6">
                    <NavLink to="/login">
                      <button className="bg-[#E04343] text-white hover:bg-[#c93636] rounded-full py-[14px] px-[36px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 shadow-xl shadow-red-900/40 hover:shadow-2xl hover:-translate-y-1 w-full sm:w-auto">Ship Now</button>
                    </NavLink>
                    <NavLink to="/become-a-rider">
                      <style>{`
            @keyframes cta-glow {
                0%, 100% { box-shadow: 0 0 5px rgba(255,255,255,0.4), 0 0 20px rgba(224,67,67,0.3); }
                50% { box-shadow: 0 0 10px rgba(255,255,255,0.6), 0 0 40px rgba(224,67,67,0.5); }
            }
            .rider-cta-glow { animation: cta-glow 2s ease-in-out infinite; }
        `}</style>
                      <button className="bg-[#E04343] text-white hover:bg-[#c93636] rounded-full py-[14px] px-[36px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 shadow-xl shadow-red-900/40 hover:shadow-2xl hover:-translate-y-1 w-full sm:w-auto">
                        Become a Rider
                      </button>
                    </NavLink>
                  </div>
                </div>

              </div>
            </div>

          </Carousel.Item>
          <Carousel.Item>
            <div className="relative">
              <img src="/images/banner2.png" alt="hero" className='w-full' />
              <div className="absolute top-7 md:top-28 lg:top-48 left-10">
                <h1 className="text-white text-[40px] md:text-[70px] font-black leading-[70px]">What's The Real Cost<br /> Of Peace Of Mind? </h1>
                <div className='w-[470px] h-[4px] bg-[#fff] mt-6'></div>
                <div className='pt-6'>
                  <h3 className="text-white md:text-[30px] text-[20px] uppercase font-bold leading-[35px]">  Knowing your shipping <br />cost in seconds!</h3>
                </div>
                <NavLink to="/login">
                  <div className="mt-6">
                    <button className=" bg-green-600 text-white rounded-[8px] py-[4px]  md:py-[10px] px-[10px] md:px-[35px] text-[12px] md:text-[27px] font-bold uppercase">Calculate Rates</button>
                  </div>
                </NavLink>

              </div>
            </div>

          </Carousel.Item>
          <Carousel.Item>
            <div className="relative">
              <img src="/images/banner3.png" alt="hero" className='w-full' />
              <div className="absolute top-7 md:top-28 lg:top-48 left-10">
                <h1 className="text-white text-[40px] md:text-[70px] font-black leading-[70px]">Let Us Handle the <br />Heavy Lifting For You</h1>
                <div className='w-[470px] h-[4px] bg-[#fff] mt-6'></div>
                <div className='pt-3'>
                  <h3 className="text-white md:text-[30px] text-[20px] uppercase font-bold leading-[35px]">Sign Up Now For Exclusive, <br />customised service!</h3>
                </div>
                <NavLink to="/contact-us">
                  <div className="mt-5">
                    <button className="bg-[#FE0503] text-white rounded-[8px] py-[4px]  md:py-[10px] px-[10px] md:px-[35px] text-[12px] md:text-[27px] font-bold uppercase">Connect me with an Expert</button>
                  </div>
                </NavLink>

              </div>
            </div>

          </Carousel.Item>
          <Carousel.Item>
            <div className="relative">
              <img src="/images/banner4.png" alt="hero" className='w-full' />
              <div className="absolute top-7 md:top-28 lg:top-48 left-10">
                <h1 className="text-white text-[40px] md:text-[70px] font-black leading-[70px]">Your Shipping, <br />Your Way</h1>
                <div className='w-[380px] h-[4px] bg-white mt-3'></div>
                <div className='pt-3'>
                  <h3 className="text-white md:text-[30px] text-[20px] uppercase font-bold leading-[35px]">Schedule Your <br />pickup Immediately!</h3>
                </div>
                <NavLink to="/login">
                  <div className="mt-5">
                    <button className="bg-green-600 text-white rounded-[8px] py-[4px]  md:py-[10px] px-[10px] md:px-[35px] text-[12px] md:text-[27px] font-bold uppercase">Schedule Pickup</button>
                  </div></NavLink>

              </div>
            </div>

          </Carousel.Item>

        </Carousel>
      </div>

      {/* End Section */}


      {/* ── Rider & Fleet Agent Callout — ATTENTION GRABBING ─── */}
      <div className="relative overflow-hidden">
        {/* Animated gradient background */}
        <style>{`
    @keyframes gradient-shift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
    }
    @keyframes float-up {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-8px); }
    }
    .rider-bg {
        background: linear-gradient(-45deg, #1a1a2e, #16213e, #0f3460, #1a1a2e);
        background-size: 400% 400%;
        animation: gradient-shift 8s ease infinite;
    }
    .float-card {
        animation: float-up 3s ease-in-out infinite;
    }
`}</style>


        <div className="rider-bg">
          {/* Decorative circles */}
          <div className="absolute top-[-50px] right-[-50px] w-[200px] h-[200px] bg-[#E04343] opacity-[0.15] rounded-full" />
          <div className="absolute bottom-[-30px] left-[-30px] w-[150px] h-[150px] bg-[#E04343] opacity-[0.1] rounded-full" />
          <div className="absolute top-[30%] left-[15%] w-[80px] h-[80px] bg-[#E04343] opacity-[0.08] rounded-full" />
          <div className="relative xl:max-w-[1280px] mx-auto px-6 sm:px-16 py-10 md:py-16">
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
              {/* Left content */}
              <div className="flex-1 text-center md:text-left">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 bg-white bg-opacity-20 backdrop-blur-sm border border-white border-opacity-30 rounded-full px-4 py-1.5 mb-5">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full animate-pulse" />
                  <span className="text-white text-[12px] font-bold uppercase tracking-wider">🔥 Now Accepting Applications</span>
                </div>

                <h2 className="text-white text-[28px] md:text-[44px] font-extrabold leading-tight mb-4 drop-shadow-lg">
                  Earn Money Delivering <br className="hidden md:block" />
                  Packages With Skynet
                </h2>

                <p className="text-white text-opacity-90 text-[15px] md:text-[17px] leading-relaxed mb-6 max-w-[500px] mx-auto md:mx-0">
                  Join Skynet as a delivery rider or fleet agent. Set your own pace, earn competitive rates, and get paid directly to your bank account. No experience needed — we'll get you started.
                </p>

                {/* Stats */}
                <div className="flex justify-center md:justify-start gap-8 mb-8">
                  <div>
                    <p className="text-white text-[28px] md:text-[36px] font-extrabold drop-shadow">Up to 1k</p>
                    <p className="text-white text-opacity-70 text-[12px] uppercase tracking-wide">Per Delivery</p>
                  </div>
                  <div className="w-[1px] bg-white bg-opacity-30" />
                  <div>
                    <p className="text-white text-[28px] md:text-[36px] font-extrabold drop-shadow">24hr</p>
                    <p className="text-white text-opacity-70 text-[12px] uppercase tracking-wide">Fast Payout</p>
                  </div>
                  <div className="w-[1px] bg-white bg-opacity-30" />
                  <div>
                    <p className="text-white text-[28px] md:text-[36px] font-extrabold drop-shadow">200+</p>
                    <p className="text-white text-opacity-70 text-[12px] uppercase tracking-wide">Active Riders</p>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
                  <NavLink to="/become-a-rider">
                    <button className="bg-white text-[#E04343] hover:bg-gray-100 rounded-full py-[14px] px-[36px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 w-full sm:w-auto">
                      Become a Rider
                    </button>
                  </NavLink>
                  <NavLink to="/become-a-rider">
                    <button className="border-2 border-white text-white hover:bg-white hover:text-[#E04343] rounded-full py-[14px] px-[36px] text-[16px] font-bold uppercase tracking-wide transition-all duration-300 w-full sm:w-auto">
                      Become a Fleet Agent
                    </button>
                  </NavLink>
                </div>
              </div>

              {/* Right card */}
              <div className="flex-1 flex justify-center md:justify-end">
                <div className="relative float-card">
                  <div className="bg-white rounded-2xl p-6 shadow-2xl max-w-[350px] relative z-10">
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-12 h-12 bg-[#E04343] rounded-full flex items-center justify-center shadow-lg">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-[#1C1C1C] text-[15px]">Start Earning Today</p>
                        <p className="text-gray-500 text-[12px]">Simple 3-step process</p>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"><span className="text-green-700 font-bold text-[13px]">1</span></div>
                        <div><p className="font-semibold text-[14px] text-[#1C1C1C]">Apply Online</p><p className="text-gray-500 text-[12px]">Fill out the form with your details & upload documents</p></div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"><span className="text-blue-700 font-bold text-[13px]">2</span></div>
                        <div><p className="font-semibold text-[14px] text-[#1C1C1C]">Get Verified</p><p className="text-gray-500 text-[12px]">We verify your NIN & documents within 24 hours</p></div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"><span className="text-purple-700 font-bold text-[13px]">3</span></div>
                        <div><p className="font-semibold text-[14px] text-[#1C1C1C]">Start Delivering</p><p className="text-gray-500 text-[12px]">Pick up shipments & earn money per delivery</p></div>
                      </div>
                    </div>
                  </div>
                  <div className="absolute -top-4 -right-4 w-full h-full bg-white rounded-2xl -z-0 opacity-20" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Start Section */}
      <div className='bg-[#E04343] sm:px-16 px-6 flex justify-center items-start py-2' >
        <div className=' w-full'>
          <NavLink to="/tracking-page" className="">
            <div className="flex justify-center items-center">
              <div>
                <h1 className="text-[20px] font-bold hover:font-semibold leading-[33px] text-white">Track Your Order</h1>
              </div>
            </div>
          </NavLink>
          <div>
            <form onSubmit={handleSubmit}>
              <div className='flex items-center  mx-auto md:w-2/5'>
                <div className="w-full  lg:pr-4">
                  <input
                    type="text"
                    className="bg-white border-[0.5px] border-[#ECEEF6] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#C4C4C4] placeholder:text-[12px]  ease-linear transition-all duration-150"
                    placeholder="Enter Shipment Number"
                    name="TrackingId"
                    onChange={(e: any) => setInputValue(e?.target?.value)}
                    required
                  />

                </div>
                <div>
                  <button type="submit" className="inline-flex items-center py-2 px-3 ml-2 text-sm font-medium text-white bg-[#b70505] rounded-[5px]">
                    Track
                  </button>
                </div>
              </div>
            </form>
          </div>



        </div>
      </div>
      {/* End Section */}

      {/* Start Section */}
      <div className='bg-[#FFFFFF] sm:px-16 px-6 md:flex md:justify-center items-start md:py-10' >
        <div className='xl:max-w-[1200px] w-full mx-auto'>
          <div className="flex justify-center items-center">
            <div>
              <h1 className="text-[26px] font-bold leading-[33px]">Why Choose Us?</h1>
              <div className='w-[90px] h-1 bg-[#E04343] mx-auto mt-3'></div>
            </div>
          </div>

          <div className='grid grid-cols-1 lg:grid-cols-4 mt-10'>
            <div>
              <div className="flex justify-center">
                <img src="/images/truck.png" alt="hero" />
              </div>
              <h3 className="text-[17px] font-[500] text-center">Timely Delivery</h3>
            </div>

            <div>
              <div className="flex justify-center">
                <img src="/images/user.png" alt="hero" />
              </div>
              <h3 className="text-[17px] font-[500] text-center mt-5">Exceptional Customer <br /> Service </h3>
            </div>

            <div>
              <div className="flex justify-center">
                <img src="/images/calender.png" alt="hero" />
              </div>

              <h3 className="text-[17px] font-[500] text-center mt-5">Flexible</h3>
            </div>

            <div>
              <div className="flex justify-center">
                <img src="/images/hand.png" alt="hero" />
              </div>
              <h3 className="text-[17px] font-[500] text-center mt-5">Reliable</h3>
            </div>

          </div>
        </div>
      </div>
      {/* End Section */}

      {/* Start Section */}
      <div className='bg-[#FFFFFF] sm:px-16 px-6 flex justify-center items-start md:pt-10' >
        <div className='xl:max-w-[1280px] w-full'>
          <section className='flex md:flex-row flex-col sm:py-16 py-6'>
            <div className='flex-1 flex-col justify-center items-start  '>
              <div>
                <iframe className="w-full h-full aspect-video " src="https://www.youtube.com/embed/OXRPnjMjZ4Y?si=YOavEdmEnWwg1T5I" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
              </div>
            </div>

            <div className='flex-1 flex flex-col md:ml-[80px] ml-0  relative'>

              <div>
                <h1 className="text-[19px] font-semibold leading-[24px]">About Us</h1>
                <div className='w-[60px] h-1 bg-[#E04343] mt-3'></div>
              </div>
              <div className="mt-10">
                <h1 className="text-[28px] font-bold leading-[36.4px]">MODERN & TRUSTED <br />LOGISTICS COMPANY</h1>
                <p className="text-[16px] leading-[25px] mt-3 text-black">The SkyNet Worldwide Express network stretches across all continents, providing the Global business community with fast, reliable and secure Express delivery services to almost every country and territory Worldwide. Our Global Network of offices provides you global reach, competitive transit time, online tracking and proof of delivery.</p>
                <p className="text-[16px] leading-[25px] mt-3 text-black">What’s more, our fast, efficient and reliable global express services
                  are underpinned by a powerful and user-friendly web- based
                  system. This system features on-line tracking, proof of delivery,
                  electronic invoicing and smart dispatch systems.</p>
                <NavLink to="/about-us">
                  <div className="mt-4">
                    <button className="bg-[#E04343] text-white rounded-[100px] px-[24px] py-[12px]">
                      Learn More
                    </button>
                  </div></NavLink>

              </div>




            </div>

          </section>
        </div>
      </div>
      {/* End Section */}



      {/* Start Section */}
      <Testimonials />
      {/* End Section */}

      {/* Start Section */}
      <OurClient />
      {/* End Section */}

      {/* Start Section - Contact / Get In Touch */}
      <section className="bg-[#f7f7f7] py-12 md:py-20 px-6 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-[26px] md:text-[40px] font-black text-[#1a1a1a] uppercase leading-tight">
              For Request &amp; Complaints
            </h2>
            <div className="w-[70px] h-[4px] bg-[#E04343] mx-auto mt-4"></div>
            <p className="text-[14px] md:text-[16px] text-[#555] mt-4 max-w-xl mx-auto">
              Reach us anytime — our team is ready to help you ship with confidence.
            </p>
          </div>

          <div className="bg-[#E04343] rounded-3xl shadow-xl shadow-red-900/20 p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
              {/* Enquiry */}
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-11 h-11 rounded-full bg-white/15 flex items-center justify-center">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="white" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-[13px] uppercase tracking-wide font-semibold">Enquiry</p>
                  <a href="tel:07000759638" className="block text-white text-[16px] md:text-[18px] font-bold hover:underline">07000759638</a>
                  <a href="tel:08168706633" className="block text-white text-[16px] md:text-[18px] font-bold hover:underline">08168706633</a>
                </div>
              </div>

              {/* E-commerce */}
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-11 h-11 rounded-full bg-white/15 flex items-center justify-center">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="white" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-[13px] uppercase tracking-wide font-semibold">E-commerce</p>
                  <a href="tel:09134446208" className="block text-white text-[16px] md:text-[18px] font-bold hover:underline">09134446208</a>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-11 h-11 rounded-full bg-white/15 flex items-center justify-center">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m5.79 14.17c-.24.68-1.42 1.31-1.96 1.35c-.5.04-.99.21-3.4-.71c-2.87-1.13-4.68-4.06-4.82-4.25c-.14-.19-1.15-1.53-1.15-2.92s.73-2.07 1-2.35c.24-.26.53-.33.71-.33c.18 0 .36.002.51.01c.16.007.39-.06.6.46c.24.58.81 2 .88 2.15c.07.14.12.31.02.5c-.09.19-.14.31-.28.48c-.14.17-.29.37-.42.5c-.14.14-.28.28-.12.55c.16.28.71 1.17 1.53 1.9c1.05.94 1.94 1.23 2.21 1.37c.28.14.44.12.6-.07c.16-.19.69-.81.88-1.08c.19-.28.37-.23.62-.14c.25.09 1.6.76 1.87.9c.28.14.46.21.53.33c.07.11.07.65-.17 1.32" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-[13px] uppercase tracking-wide font-semibold">WhatsApp</p>
                  <a href="https://wa.me/2349134446208" target="_blank" rel="noopener noreferrer" className="block text-white text-[16px] md:text-[18px] font-bold hover:underline">Chat with us on WhatsApp</a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-11 h-11 rounded-full bg-white/15 flex items-center justify-center">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Zm0 2v.01L12 11l8-4.99V6H4Zm16 12V8.24l-8 4.99l-8-4.99V18h16Z" fill="white" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-[13px] uppercase tracking-wide font-semibold">Email</p>
                  <a href="mailto:cs@skynetworldwide.com.ng" className="block text-white text-[16px] md:text-[18px] font-bold hover:underline break-all">cs@skynetworldwide.com.ng</a>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4 md:col-span-2 border-t border-white/20 pt-8">
                <div className="shrink-0 w-11 h-11 rounded-full bg-white/15 flex items-center justify-center">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Zm0 9.5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5Z" fill="white" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-[13px] uppercase tracking-wide font-semibold">Head Office</p>
                  <p className="text-white text-[16px] md:text-[18px] font-bold leading-snug">
                    19/21 Balogun street, off Akinremi Street, Anifowoshe, Ikeja, Lagos, Nigeria
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <NavLink to="/contact-us">
                <button className="bg-white text-[#E04343] hover:bg-gray-100 rounded-full py-[12px] px-[32px] text-[15px] font-bold uppercase tracking-wide transition-all duration-300">
                  Contact Us
                </button>
              </NavLink>
              <a href="https://wa.me/2349134446208" target="_blank" rel="noopener noreferrer">
                <button className="border-2 border-white text-white hover:bg-white hover:text-[#E04343] rounded-full py-[12px] px-[32px] text-[15px] font-bold uppercase tracking-wide transition-all duration-300">
                  Chat on WhatsApp
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* End Section - Contact */}

      <div>
        <Footer />
      </div>
      {/* End Section */}








    </>
  )
}

export default Home;